import { render, staticRenderFns } from "./TheRegroupementsPage.vue?vue&type=template&id=f8aa2b58&scoped=true&"
import script from "./TheRegroupementsPage.vue?vue&type=script&lang=js&"
export * from "./TheRegroupementsPage.vue?vue&type=script&lang=js&"
import style0 from "./TheRegroupementsPage.vue?vue&type=style&index=0&id=f8aa2b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8aa2b58",
  null
  
)

component.options.__file = "TheRegroupementsPage.vue"
export default component.exports